import type { NextPage } from "next";

import Page from "components/layout/page";
import NextSectionAction from "components/next-section-action";
import BuiltForStakeholders from "components/views/solar-financing-operating-system/built-for-stakeholders";
import OperatingSystemCategories from "components/views/solar-financing-operating-system/categories";
import FaqSection from "components/views/solar-financing-operating-system/faq-section";
import GetStarted from "components/views/solar-financing-operating-system/get-started";
import InfrastructureCredentials from "components/views/solar-financing-operating-system/infrastructure-credentials";
import MainHero from "components/views/solar-financing-operating-system/main-hero";
import OperatingSystem from "components/views/solar-financing-operating-system/operating-system";
import PartnershipModel from "components/views/solar-financing-operating-system/partnership-model";

const SolarFinancingOperatingSystem: NextPage = () => (
  <Page
    title="Solar Financing Operating System for Lenders, Funds & TPOs | Operating System by Enerflo"
    description="Run your solar lending, funding or TPO operation on Enerflo’s native operating system. Origination, decisioning, document signing, homeowner portal, and portfolio intelligence — all in one place."
  >
    <MainHero />
    <InfrastructureCredentials />
    <OperatingSystem />
    <PartnershipModel />
    <OperatingSystemCategories />
    <BuiltForStakeholders />
    <FaqSection />
    <GetStarted />
    <NextSectionAction
      buttonText="View Virtual Sales Rep (VSR)"
      url="/features/virtual-sales-rep"
      description="Qualify leads online 24/7"
    />
  </Page>
);

export default SolarFinancingOperatingSystem;
